import { FC } from "react";
import TimeCountdownComponent from "../../../../../common/components/time-countdown/time-countdown.component";
import dateService from "../../../../../common/utils/date/date.service";
import orderTranslationsHelper from "../../../../../languages/order-translations.helper";
import ClockIconComponent from "../../../../order-optimizer/common/icons/clock-icon-component";

type OrderActiveListingTableTimeToStartProps = {
  timeToStart: Date;
  timeToAccept: Date | null;
};

const OrderActiveListingTableTimeToStartComponent: FC<
  OrderActiveListingTableTimeToStartProps
> = (props) => {
  const translations = orderTranslationsHelper.getActiveListingTranslations();

  return (
    <>
      {props.timeToAccept !== null && (
        <div className="order_active_listing_time_to_accept">
          <TimeCountdownComponent
            dateTo={props.timeToAccept}
            className="order_active_listing_time_to_accept__timer"
            expiredClassName="order_active_listing_time_to_accept__timer_expired"
          />
          <ClockIconComponent className="order_active_listing_time_to_accept__clock" />
        </div>
      )}
      <span>{dateService.formatDateTime(props.timeToStart)}</span>
      <div className="order_active_listing_time_to_start">
        {translations.table.timeToStartPrefix}:
        <TimeCountdownComponent dateTo={props.timeToStart} />
      </div>
    </>
  );
};

export default OrderActiveListingTableTimeToStartComponent;
